<template>
  <Layout id="Entrepreneurship-Page">
    <detailsSection :details="details" />
    <div id="course-wrapper" class="container mx-auto" v-if="showAllCourses">
      <template v-for="(course,i) in courses">
        <homeCardComponent
          :key="i"
          :iterator="i"
          :course_id="course.id"
          :name="course.title"
          :listing_id= "course.listing_id"
          :image="course.bgImage"
          :url="course.url"
          :status="course.status"
          :availablity="course.status === 'available' ? course.start_date : status[course.status].name"
          :description="course.description"
          :full_description="course.full_description"
          :objectives="course.objectives"
          :outline="course.outline"
        />
      </template>
    </div>
    <div id="course-wrapper" class="container mx-auto" v-if="completed">
      <template v-for="(course,i) in groupedCourses.completed">
        <homeCardComponent
          :key="i"
          :iterator="i"
          :course_id="course.id"
          :name="course.title"
          :image="course.bgImage"
          :listing_id= "course.listing_id"
          :url="course.url"
          :status="course.status"
          :availablity="course.status === 'available' ? course.start_date : status[course.status].name"
          :description="course.description"
          :full_description="course.full_description"
          :objectives="course.objectives"
          :outline="course.outline"
        />
      </template>
    </div>
    <div id="course-wrapper" class="container mx-auto" v-if="active">
      <template v-for="(course,i) in groupedCourses.active">
        <homeCardComponent
          :key="i"
          :iterator="i"
          :course_id="course.id"
          :name="course.title"
          :listing_id= "course.listing_id"
          :url="course.url"
          :image="course.bgImage"
          :status="course.status"
          :availablity="course.status === 'available' ? course.start_date : status[course.status].name"
          :description="course.description"
          :full_description="course.full_description"
          :objectives="course.objectives"
          :outline="course.outline"
        />
      </template>
    </div>

    <transition name="fade">
      <section v-if="!showFixedCourses" class="register-section bg-grey border position-fixed">
        <div class="fixed-register d-flex flex-wrap align-items-center container">
          <div class="text-center w-100">
            <ul class="d-flex justify-content-center align-items-center m-0 p-3 list-style-none">
              <li class="mx-2 inprogress">
                <a
                  href="javascript:void(0)"
                  data-attribute="ENT-page"
                  data-event="link"
                  data-action="click"
                  data-name="onclick"
                  data-type="internal link"
                  data-region="main content"
                  data-section="secondary navbar"
                  data-text="in progress"
                  :class="{'diabled': enrolledDisabled , 'isActive' : active}"
                  @click="filter('active')"
                >In progress ({{this.groupedCourses.active ? (this.groupedCourses.active.length) : 0 }})</a>
              </li>
              <li class="mx-2 completed">
                <a
                  href="javascript:void(0)"
                  data-attribute="ENT-page"
                  data-event="link"
                  data-action="click"
                  data-name="onclick"
                  data-type="internal link"
                  data-region="main content"
                  data-section="secondary navbar"
                  data-text="completed"
                  :class="{'diabled': completedDisabled, 'isActive' : completed}"
                  @click="filter('completed')"
                >Completed ({{this.groupedCourses.completed ? this.groupedCourses.completed.length : 0 }})</a>
              </li>
              <li class="mx-2 all">
                <a
                  :class="{'isActive': showAllCourses}"
                  data-event="link"
                  data-action="click"
                  data-name="onclick"
                  data-type="internal link"
                  data-region="main content"
                  data-section="secondary navbar"
                  data-text="all courses"
                  href="javascript:void(0)"
                  data-attribute="ENT-page"
                  @click="filter('all')"
                >All courses ({{this.courses ? this.courses.length : 0 }})</a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </transition>
    <section class="register-section bg-grey border position-relative">
      <div class="fixed-register d-flex flex-wrap align-items-center container">
        <div class="text-center w-100">
          <ul class="d-flex justify-content-center align-items-center m-0 p-3 list-style-none">
            <li class="mx-2 inprogress">
              <a
              data-event="link"
                  data-action="click"
                  data-name="onclick"
                  data-type="internal link"
                  data-region="main content"
                  data-section="secondary navbar"
                  data-text="in progress"
                href="javascript:void(0)"
                data-attribute="ENT-page"
                :class="{'diabled': enrolledDisabled , 'isActive' : active}"
                @click="filter('active')"
              >In progress ({{this.groupedCourses.active ? (this.groupedCourses.active.length) : 0 }})</a>
            </li>
            <li class="mx-2 completed">
              <a
              data-event="link"
                  data-action="click"
                  data-name="onclick"
                  data-type="internal link"
                  data-region="main content"
                  data-section="secondary navbar"
                  data-text="completed"
                href="javascript:void(0)"
                data-attribute="ENT-page"
                :class="{'diabled': completedDisabled, 'isActive' : completed}"
                @click="filter('completed')"
              >Completed ({{this.groupedCourses.completed ? this.groupedCourses.completed.length : 0 }})</a>
            </li>
            <li class="mx-2 all">
              <a
                data-event="link"
                  data-action="click"
                  data-name="onclick"
                  data-type="internal link"
                  data-region="main content"
                  data-section="secondary navbar"
                  data-text="all courses"
                :class="{'isActive': showAllCourses}"
                href="javascript:void(0)"
                data-attribute="ENT-page"
                @click="filter('all')"
              >All courses ({{this.courses ? this.courses.length : 0 }})</a>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="course_info bg-grey pt-96 pb-96" id="course-section">
      <b-container>
        <h4 class="font48 font-weight-bold">Course information</h4>
        <template v-for="(faq,i) in faqs">
          <div class="question-1 mt-64 mb-64" :key="i">
            <h3 class="font24 font-weight-bold">{{faq.q}}</h3>
            <div class="border-halfway my-32"></div>
            <p class="font18 width-restriction">{{faq.a}}</p>
          </div>
        </template>
        <p class="font18 font-weight-bold">
          Have more questions? View our
          <a href="/faq" data-attribute="ENT-page"
          data-event="link"
                  data-action="click"
                  data-name="onclick"
                  data-type="internal link"
                  data-region="main content"
                  data-section="course information"
                  data-text="faq">FAQ</a> page.
          
        </p>
      </b-container>
    </section>
    <b-modal
      id="create-account"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-footer
    >
    <template v-slot:modal-header="{ close }">
      <button data-event="modal" data-name="onclick" data-type="click" data-region="modal" data-section="welcome user" data-text="close" type="button" @click="close(),closeTheModal()" aria-label="Close" data-action="close" class="close">×</button>
      <h5 class="modal-title">Create an account</h5>
    </template>
      <div class="container">
        <RegisterComponent />
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import Layout from "../layouts/main";
import homeCardComponent from "../components/courseComponents";
import detailsSection from "../components/detailsSection";
import { LOAD_ITEMS } from "../store/actions.type";
import { mapGetters } from "vuex";
import RegisterComponent from "../components/register";
import { entCourses, groupedCourses } from "../common/courses.filter";
import mockCourses from "../assets/data/mockCourses.json";
import ent from "../assets/data/ent.json";
export default {
  name: "Entrepreneurship-Page",
  data() {
    return {
      status: {
        active: {
          name: "In progress"
        },
        completed: {
          name: "Completed"
        }
      },
      details: ent.data.details,
      availablity: "Start any time",
      showAllCourses: true,
      courses: [],
      completed: false,
      active: false,
      showFixedCourses: true,
      completedDisabled: false,
      enrolledDisabled: false,
      componentKey: 0,
      groupedCourses: [],
      shadowCourses: [],
      faqs: [
        {
          q:
            "How long does it take to complete a single entrepreneurship course?",
          a:
            "The course material is 8 hours of content. It is recommended you spend 8 hours a week on a single course."
        },
        {
          q:
            "How long does it take to complete the entire series of entrepreneurship courses?",
          a: "If you complete all 5 courses you can expect to spend 45 hours to complete the series."
        }
      ]
    };
  },
  mounted() {
    if (Object.keys(this.groupedCourses).indexOf("completed") < 0) {
      this.completedDisabled = true;
    }
    if (Object.keys(this.groupedCourses).indexOf("active") < 0) {
      this.enrolledDisabled = true;
    }
  },
  methods: {
    closeTheModal(){
      utag.link({
        event: 'modal',
        action: 'close',
        name: 'onclick',
        type: 'click',
        region: 'modal',
        section: 'create an account',
        text: 'close',
        tealium_event: 'close_modal'
    })
    },
    filter(value) {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $("#course-wrapper").offset().top
        },
        800
      );
      if (value === "completed") {
        this.completed = true;
        this.showAllCourses = false;
        this.active = false;
      } else if (value === "active") {
        this.completed = false;
        this.showAllCourses = false;
        this.active = true;
      } else {
        this.completed = false;
        this.showAllCourses = true;
        this.active = false;
      }
    },
    handleScroll(event) {
      if (
        window.pageYOffset >= document.getElementById("section-0").offsetTop &&
        window.pageYOffset <=
          document.getElementById("course-section").offsetTop -
            ($(window).height() + $(window).height() / 3)
      ) {
        this.showFixedCourses = false;
      } else {
        this.showFixedCourses = true;
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  components: { Layout, detailsSection, homeCardComponent, RegisterComponent },
  computed: {
    ...mapGetters(["currentUser"])
  },
  beforeMount() {
    this.courses = entCourses(this.currentUser);
    this.shadowCourses = this.courses;
    this.groupedCourses = groupedCourses(this.courses);
    this.showFixedCourses = true;
  }
};
</script>
